import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import SEOHead from "@/components/SEOHead";
import SkipLink from "@/components/SkipLink";
import { useSEO } from "@/hooks/useSEO";

const ContactPage = () => {
  useSEO({
    title: "Contact Smartborn - Get in Touch | Global IT Services",
    description: "Contact Smartborn for enterprise IT services, software development, and consulting. Reach our offices in Bangalore, Melbourne, and Chicago. Phone: +91 98869 28201",
    keywords: "contact smartborn, get in touch, IT services inquiry, consultation request, office locations, bangalore office, melbourne office, chicago office",
    canonical: "https://smartborn.io/contact",
    ogType: "website"
  });

  return (
    <>
      <div className="min-h-screen">
        <SEOHead />
        <SkipLink />
        <Navigation />
        <main id="main-content" tabIndex={-1}>
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
